/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from 'react';
import { Button, OnboardingContainer } from '../styles';
import { OnboardingQuestion } from '../question/question';
// import { Notification } from '../../../components/notification/';
import { useOnboarding } from '../../../contexts/onboarding-context';
// import { Header, NavTitle } from '../../../components/common/header';
import { Main } from '../prepearing/styles';
import { Header } from '../../chat/header/header';
import {
  Notification,
  NotificationHeader,
  NotificationDescription,
  Pill,
  PillDot,
  PillText,
  NotificationDate,
} from '../prepearing/styles';
import { screenTransition } from '../animations';
// import { StartOnboarding } from './styles';

export const OnboardingReady: React.FC = () => {
  const [showQuestions, setShowQuestions] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const { questions, loadQuestions } = useOnboarding();

  // Preload questions in the background
  useEffect(() => {
    if (questions.length === 0) {
      loadQuestions().catch((error) => {
        console.error('Error preloading questions:', error);
      });
    }
  }, [questions.length]);

  const handleStartOnboarding = () => {
    setIsTransitioning(true);
    // Wait for animation to complete before showing questions
    setTimeout(() => {
      setShowQuestions(true);
    }, 300);
  };

  if (showQuestions) {
    // Pass a loading state to OnboardingQuestion if needed
    return <OnboardingQuestion />;
  }

  return (
    <OnboardingContainer>
      <Header
        onNotificationClick={() => {}}
        onProfileClick={() => {}}
      ></Header>
      <Main>
        <div style={{ width: '215px', marginBottom: '16px', placeSelf: 'center' }}>
          <img
            src="/main-logo-white.svg"
            alt="Mailander Logo"
            style={{ width: '100%', height: '100%' }}
          />
        </div>
        <Notification css={screenTransition(isTransitioning)}>
          <NotificationHeader>
            <Pill>
              <PillDot />
              <PillText>New from Chris</PillText>
            </Pill>
            <NotificationDate>{new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</NotificationDate>
          </NotificationHeader>
          <NotificationDescription>
            Your onboarding flow is ready for you. Click on the button below and start now
          </NotificationDescription>
          {/* <StartOnboarding onClick={handleStartOnboarding}>Start Onboarding</StartOnboarding> */}
          <Button style={{ width: '100%' }} primary onClick={handleStartOnboarding}>
            Start Onboarding
          </Button>
        </Notification>
      </Main>
    </OnboardingContainer>
  );
};
